export default __webpack_public_path__ + "static/media/edit-icon.21f5efef.svg";